import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useSeo } from "../lib/seo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [msg, setMsg] = useState("Signing you in…");
  useSeo({ title: "Signing in… — Brand and Behavior", noindex: true });

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { setMsg("No session in URL. Redirecting…"); setTimeout(() => navigate("/login", { replace: true }), 1200); return; }
    const session_id = m[1];

    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        // Clear hash so we don't re-process on refresh
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        await refresh();
        let nextPath = "/dashboard";
        try {
          nextPath = sessionStorage.getItem("post_auth_next") || nextPath;
          sessionStorage.removeItem("post_auth_next");
        } catch (err) {
          console.warn("sessionStorage unavailable:", err);
        }
        navigate(nextPath, { replace: true });
      } catch (err) {
        console.error("Auth session exchange failed:", err);
        setMsg("Sign-in failed. Try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <main className="app-main" data-testid="auth-callback">
      <section className="page-hero">
        <div className="kicker">Authenticating</div>
        <h1>{msg}</h1>
      </section>
    </main>
  );
}
